import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import Status from '../../../elements/Status'
import {Button} from 'antd'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import UpperCaseCell from '../../../elements/Table/Cells/UpperCaseCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import TitleCaseCell from '../../../elements/Table/Cells/TitleCaseCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

function List(props) {
  const {
    fetch,
    setBudget,
    onShow,
    fetching,
    list,
    company,
    onChangeCompany,
  } = props

  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({original, value}) => (
        <a
          onClick={() => {
            setBudget(original)
            onShow()
          }}>
          {value}
        </a>
      ),
    },
    {
      Header: 'Title',
      accessor: 'title',
      width: 400,
    },
    {
      Header: 'Center',
      accessor: 'center.name',
      width: 400,
    },
    {
      Header: 'Fiscal',
      accessor: 'fiscal',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 400,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: TitleCaseCell,
    },
    {
      Header: 'Target',
      accessor: 'target',
      style: {textAlign: 'right'},
      Cell: MoneyCell,
    },
    {
      Header: 'Requisitioned',
      accessor: 'requisitioned',
      style: {textAlign: 'right'},
      Cell: MoneyCell,
    },
    {
      Header: 'Actual',
      accessor: 'actual',
      style: {textAlign: 'right'},
      Cell: MoneyCell,
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      Cell: UpperCaseCell,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: StatusCell,
    },
  ]
  return (
    <CustomTable
      CreateButton={() => (
        <Button
          type="primary"
          icon={'plus'}
          size={'small'}
          onClick={() => {
            setBudget({})
            onShow()
          }}>
          New
        </Button>
      )}
      columns={columns}
      fetch={fetch}
      fetching={fetching}
      data={list}
      isFilterable={true}
      defaultPageSize={20}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{width: '450px', paddingRight: 20, float: 'right'}}
        />
      )}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
